import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import CheckboxBlank from '@/assets/icons/checkbox-blank.svg';
import CheckboxMarked from '@/assets/icons/checkbox-marked.svg';
import CheckboxIndeterminate from '@/assets/icons/checkbox-indeterminate.svg';
import RadioOff from '@/assets/icons/radio-off.svg';
import RadioOn from '@/assets/icons/radio-on.svg';
import ChevronDown from '@/assets/icons/chevron-down.svg';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#d7eef9', // blue
        secondary: '#1592e6',
        journey: { base: '#d7eef9', lighten1: '#ebf7fc', lighten2: '#f1f8fd' },
        journeySecondary: '#1592e6',
        deepening: { base: '#e9e0fe', lighten1: '#f4f0ff', lighten2: '#f9f8fe' },
        deepeningSecondary: '#9068de',
        lightening: { base: '#fff7a5', lighten1: '#fffac5', lighten2: '#fffef1' },
        lighteningSecondary: {
          lighten1: '#FFE701',
          base: '#f4dd00',
          darken1: '#f4dd00',
        },
        anchor: '#0079ca',
        error: '#ec407a',
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 0,
      sm: 340,
      md: 600,
      lg: 980,
      xl: 1440,
    },
  },
  icons: {
    values: {
      checkboxOff: {
        component: CheckboxBlank,
      },
      checkboxOn: {
        component: CheckboxMarked,
      },
      checkboxIndeterminate: {
        component: CheckboxIndeterminate,
      },
      radioOff: {
        component: RadioOff,
      },
      radioOn: {
        component: RadioOn,
      },
      dropdown: {
        component: ChevronDown,
      },
    },
  },
});
